import React from 'react'
import { media } from 'styled-bootstrap-grid'
import shadows from '../../../style/shadows'
import styled from 'styled-components'

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  ${media.max.md`
    padding: 15px;
  `}
`
export const BaseCard = styled(Flex)`
  padding: ${p => p.theme.spacing.lg};
  transition: ${p => p.theme.transition()};
  :hover {
    box-shadow: 0px 0px 20px 0px rgba(51, 51, 51, 0.05);
    border-bottom: 4px solid #01ab5d;
  }
  ${media.max.md`
    > div{
      > h4{
        margin: 10px 0 10px 0;
      }
    }
    :hover{
      border-bottom: 2px solid #01ab5d;
    }
  `}
`
const HorizonCard = styled(BaseCard)`
  text-align: left;
  width: 580px;
  max-height: 150px;
  :nth-child(2n + 1) {
    margin-right: 40px;
  }
  :not(:nth-child(n + 5)) {
    margin-bottom: 20px;
  }
  > div {
    min-width: 400px;
    > h5 {
      margin: 42px 0 18px 0;
    }
  }
  > img {
    display: inline-block;
    width: 55px;
    height: 55px;
  }
  ${media.max.md`
    min-height: 0;
    max-height: 120px;
    :nth-child(2n + 1){
      margin-right: 0px;
    }
    :not(:nth-child(n+5)) {
      margin-bottom: 10px;
    }
    > div {
      min-width: 3rem;
      max-height: 150px;
      > h5{
        margin: 10px 0 10px 0;
      }
    }
    > img {
      display: inline-block;
      width: 30px;
      height: 30px;
    }
  `}
`
const AliginCard = styled(BaseCard)`
  flex-direction: column;
  text-align: center;
  width: 280px;
  height: 220px;
  :not(:nth-child(4n)) {
    margin-right: 26px;
  }
  :not(:nth-child(n + 5)) {
    margin-bottom: 60px;
  }
  :hover {
    box-shadow: 0px 0px 20px 0px rgba(51, 51, 51, 0.1);
  }
  > div {
    min-width: 250px;
  }
  > img {
    display: inline-block;
    margin-top: 12px;
    width: 48px;
    height: 48px;
  }
  ${media.max.md`
    width: 42vw;
    padding: 10px;
    max-height: 150px;
    overflow: hidden;
    :not(:nth-child(4n)) {
      margin-right: 0px;
    }
    :nth-child(2n + 1){
      margin-right: 13px;
    }
    :not(:nth-child(n+7)) {
      margin-bottom: 30px;
    }
    > div {
      min-width: 3rem;
      max-height: 150px;
    }
    > img {
      display: inline-block;
      margin-top: 6px;
      width: 28px;
      height: 28px;
    }
    h2{
      font-size: 13px;
    }
    p{
      font-size: 9px;
    }
  `}
`

export interface CardlProps {
  children: React.ReactElement | React.ReactElement[]
  imgMargin?: string
  icon: string
}

export function HCard(props: CardlProps) {
  const { icon, imgMargin, children } = props
  return (
    <HorizonCard>
      <img src={icon} alt='' style={{ margin: imgMargin }} />
      <div>{children}</div>
    </HorizonCard>
  )
}

export function ACard(props: CardlProps) {
  const { icon, children } = props
  return (
    <AliginCard>
      <img src={icon} alt='' />
      {children}
    </AliginCard>
  )
}
